import type { Facet } from '@/types/taxonomy';

export const DOCUMENT_TAG_SUGGESTIONS = [
  'quarterly',
  'annual',
  'report',
  'analysis',
  'strategy',
  'budget',
  'presentation',
  'meeting',
  'proposal',
  'guidelines',
  'policy',
  'procedure',
  'training',
  'assessment',
  'review',
  'planning',
];

/** The submitted department is the translated label itself, not one of these keys. */
export const DEPARTMENT_LABEL_KEYS = [
  'departments.finance',
  'departments.marketing',
  'departments.engineering',
  'departments.humanResources',
  'departments.sales',
  'departments.operations',
  'departments.legal',
  'departments.executive',
];

/** Radix throws on an item with value=""; the stored empty department maps through this. */
export const DEPARTMENT_NONE = '__department_none__';

export type DocumentClassification = 'public' | 'internal' | 'confidential';

export const DOCUMENT_CLASSIFICATIONS: Array<{
  value: DocumentClassification;
  nameKey: string;
  descriptionKey: string;
}> = [
  { value: 'public', nameKey: 'metadata.public', descriptionKey: 'metadata.publicDesc' },
  { value: 'internal', nameKey: 'metadata.internal', descriptionKey: 'metadata.internalDesc' },
  {
    value: 'confidential',
    nameKey: 'metadata.confidential',
    descriptionKey: 'metadata.confidentialDesc',
  },
];

export type DocumentAccessLevel = 'private' | 'team' | 'organization';

export const DOCUMENT_ACCESS_LEVELS: Array<{ value: DocumentAccessLevel; labelKey: string }> = [
  { value: 'private', labelKey: 'metadata.privateOnly' },
  { value: 'team', labelKey: 'metadata.teamDepartment' },
  { value: 'organization', labelKey: 'metadata.organizationEveryone' },
];

/** MozyOk E1: a display policy, not a filter. Below it a candidate still shows. */
export const TAXONOMY_CONFIDENCE_THRESHOLD = 0.6;

/** Mirrors the backend `SINGLE_FACETS`. A rival here needs an explicit reject + add. */
export const SINGLE_VALUE_FACETS: readonly Facet[] = [
  'source_scope',
  'document_type',
  'authority',
];

/** Display order; a facet outside it still renders, grouped last. */
export const FACET_ORDER: readonly Facet[] = [
  'source_scope',
  'domain',
  'document_type',
  'authority',
  'product',
  'project',
  'customer',
];
